import React from 'react';
import {CaseDesignProvider} from "../context/CaseDesign.context";
import {Route} from "react-router-dom";
import AddNewDocument from "../CaseDesign/AddNewDocument";
import SettingRule from "../CaseManagementRule/SettingRule";

interface CaseDesignDocumentProps {

}

export const CaseDesignDocument: React.FunctionComponent<CaseDesignDocumentProps> = (props) => {
    return (
        <CaseDesignProvider>
            {props.children}
            {/*<Route path="/document-pages/id/:id" element={AddNewDocument}/>*/}
            {/*<Route path="/document-pages" element={AddNewDocument}/>*/}
            {/*<Route path="/document-pages/rule-setting/:id" element={SettingRule}/>*/}
        </CaseDesignProvider>
    )
}